export enum WaitingRoomStatusFiltersEnum {
  None = 0,
  AppointmentUntreated = 1,
  AppointmentTreated = 2,
}
